import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Typography, Slide } from '@material-ui/core'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import cn from 'classnames'
import { fetchAssignData, clearStore } from 'reducers/myJobs/reducer'
import Chatbot from 'components/common/Chatbot'
import ChatbotAqua from 'components/common/Chatbot/ChatbotAqua'
import FilterBar from './FilterBar'
import JobList from './JobList'
import JobCreation from './JobCreation'
import JobsNav from './JobsNav'
import './style.scss'

const MAX_JOBS_PER_PAGE = 20

class MyJobs extends Component {
  state = {
    isDialogOpen: false,
    taskLevel: false,
    createLevel: false,
    depth: [],
    isInfoModalOpen: false,
    page: 1,
    canLoadJobs: true,
    respectFilters: true,
    searchValue: '',
  }

  container = createRef()

  scrollContainer = createRef()

  componentDidMount() {
    const { location, fetchAssignData } = this.props

    if (location.search) {
      const query = new URLSearchParams(location.search)

      if (ifWindowWidthLessThan(TABLET_BREAKPOINT) && query.get('job')) {
        this.setState({
          taskLevel: true,
          depth: [
            {
              name: query.get('job'),
            },
          ],
        })
      }
    }

    fetchAssignData()
  }

  componentDidUpdate(prevProps) {
    const { licensee, fetchAssignData } = this.props

    if (licensee !== prevProps.licensee) {
      fetchAssignData()
    }
  }

  componentWillUnmount() {
    this.props.clearStore()
  }

  onCreateJob = () => {
    this.setState({ isDialogOpen: true })
  }

  onCloseDialog = () => {
    this.setState({ isDialogOpen: false })
  }

  goToJob = jobItem => {
    this.setState({
      taskLevel: true,
      depth: [
        {
          name: jobItem.title,
        },
      ],
    })
  }

  handleReturn = () => {
    const { taskLevel, createLevel } = this.state

    if (taskLevel) {
      this.setState({ taskLevel: false })
    } else if (createLevel) {
      this.setState({ createLevel: false })
    }
  }

  handleOpenInfoModal = () => {
    this.setState({ isInfoModalOpen: true })
  }

  handleCloseInfoModal = () => {
    this.setState({ isInfoModalOpen: false })
  }

  setCanLoadJobs = canLoadJobs => {
    this.setState({
      canLoadJobs,
    })
  }

  setPage = page => {
    this.setState({
      page,
    })
  }

  setRespectFilters = respectFilters => {
    this.setState({
      respectFilters,
    })
  }

  setSearchValue = searchValue => {
    this.setState({
      searchValue,
    })
  }

  handleJobsContainerScroll = (scrollHeight, scrollTop, clientHeight) => {
    const { jobList } = this.props
    const { canLoadJobs, page } = this.state
    const isBottomReached = scrollHeight - scrollTop - clientHeight <= 2

    if (
      canLoadJobs &&
      isBottomReached &&
      jobList.toArray().length >= MAX_JOBS_PER_PAGE
    ) {
      this.setPage(page + 1)
    }
  }

  render() {
    const {
      taskLevel,
      depth,
      isDialogOpen,
      isInfoModalOpen,
      page,
      searchValue,
      respectFilters,
    } = this.state
    const {
      intl: { formatMessage },
      currentApp,
      featureFlags,
    } = this.props

    return (
      <div
        className={cn('module app-my-jobs', {
          'old-header': !featureFlags.APP_HEADER_V2,
        })}>
        <div className="module-head">
          <Typography variant="h5" className="module-title">
            {currentApp.name}
          </Typography>
          <div className="module-filter">
            <FilterBar
              createWorkflow={this.onCreateJob}
              setCanLoadJobs={this.setCanLoadJobs}
              setPage={this.setPage}
              page={page}
              scrollRef={this.scrollContainer}
              searchValue={searchValue}
              respectFilters={respectFilters}
              setRespectFilters={this.setRespectFilters}
              setSearchValue={this.setSearchValue}
            />
          </div>
        </div>
        <div
          className="module-content"
          ref={this.scrollContainer}
          onScroll={({ target }) => {
            if (
              this.scrollContainer.current &&
              target === this.scrollContainer.current
            ) {
              const {
                scrollHeight,
                scrollTop,
                clientHeight,
              } = this.scrollContainer.current

              this.handleJobsContainerScroll(
                scrollHeight,
                scrollTop,
                clientHeight,
              )
            }
          }}>
          <JobList
            isPortalActive={taskLevel}
            isInfoModalOpen={isInfoModalOpen}
            portalRef={this.container}
            scrollRef={this.scrollContainer}
            onJobClick={this.goToJob}
            handleReturn={this.handleReturn}
            handleCloseInfoModal={this.handleCloseInfoModal}
            page={page}
            setPage={this.setPage}
            searchValue={searchValue}
            respectFilters={respectFilters}
          />
          {ifWindowWidthLessThan(TABLET_BREAKPOINT) && (
            <Slide in={taskLevel} direction="left">
              <div className="overlapping" ref={this.scrollContainer}>
                <JobsNav
                  breadcrumbs={depth}
                  onReturnBack={this.handleReturn}
                  handleOpenInfoModal={this.handleOpenInfoModal}
                />
                <div className="list-container" ref={this.container} />
              </div>
            </Slide>
          )}
          <JobCreation
            formatMessage={formatMessage}
            isOpen={isDialogOpen}
            isFullScreen={ifWindowWidthLessThan(TABLET_BREAKPOINT)}
            onCloseDialog={this.onCloseDialog}
          />
          {featureFlags?.APP_CHAT_BOT && <Chatbot />}
          {featureFlags?.APP_CHAT_BOT_AQUA && <ChatbotAqua />}
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    jobList: state.getIn(['myJobs', 'jobList']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    fetchAssignData,
    clearStore,
  },
)(injectIntl(MyJobs))
